import React, { Component } from 'react';
import { connect } from 'react-redux';
import { athleteSelect } from '~/store/actions/athlete';
import PropTypes from 'prop-types';
import CellScores from './scores/CellScores';
import CellJudgeScores from './scores/CellJudgeScores';

export default
@connect(
    ({ selectedAthleteId }) => ({ selectedAthleteId }),
    dispatch => ({
        athleteSelect: (...args) => dispatch(
            athleteSelect(...args)
        )
    })
)
class ScoredRow extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        style: PropTypes.object.isRequired,
        noStyle: PropTypes.object.isRequired,
        nameStyle: PropTypes.object.isRequired,
        scoreStyle: PropTypes.object.isRequired,
        colors: PropTypes.object.isRequired,
        athlete: PropTypes.object.isRequired,
        data: PropTypes.object.isRequired,
        columns: PropTypes.object.isRequired,
        roundConfig: PropTypes.object.isRequired,
        onRowRef: PropTypes.func.isRequired
    }

    static defaultProps = {
        className: ''
    }

    toggleSelect = (athlete) => {
        const {
            selectedAthleteId,
            athleteSelect
        } = this.props;

        athleteSelect(
            selectedAthleteId === athlete.externalId
                ? null
                : athlete
        );
    }

    render() {
        const {
            t,
            groupNumber,
            rowNumber,
            className,
            style,
            noStyle,
            nameStyle,
            scoreStyle,
            colors,
            data,
            athlete,
            columns,
            trickLabel,
            roundConfig,
            onRowRef,
            selectedAthleteId
        } = this.props;

        const { showJudgeScores } = roundConfig;
        const showJudgeScoresPopup = className.indexOf('show-scores-bellow') > -1;

        return [
            <div
                key={`leaderboard_timed_row_${groupNumber}_${rowNumber}`}
                className={`row row-scored ${className} ${
                    showJudgeScores && athlete.hasExtraScores
                        ? 'has-extra-scores'
                        : ''
                }`}
                style={style}
                ref={ref => onRowRef(
                    ref,
                    this.props
                )}
                onClick={() => this.toggleSelect(
                    athlete
                )}
            >
                <div className="holder-main">
                    <div
                        className="cell cell-no"
                        style={noStyle}
                    >
                        {data.rank}
                    </div>

                    {columns.Bib &&
                        <div className="cell cell-bib">
                            {data.bib}
                        </div>
                    }

                    <div className="cell cell-name">
                        <div style={nameStyle}>
                            {athlete.fullName}
                            {columns.Nation &&
                            <div className="nation">
                                {athlete.nationality}
                            </div>
                            }
                        </div>
                    </div>
                </div>

                <div className="holder-scores">
                    <CellScores
                        t={t}
                        athlete={athlete}
                        data={data}
                        roundConfig={roundConfig}
                        trickLabel={trickLabel}
                        colors={colors}
                        scoreStyle={scoreStyle}
                        showJudgeScoresPopup={
                            showJudgeScores && !!showJudgeScoresPopup
                        }
                    />
                </div>
            </div>,

            showJudgeScores
            && !showJudgeScoresPopup
            && athlete.hasExtraScores
            && selectedAthleteId === athlete.externalId
            && (
                <div
                    key={`leaderboard_scored_row_extra_${groupNumber}_${rowNumber}`}
                    className={`row row-scored row-judge-scores ${className} ${
                        selectedAthleteId === athlete.externalId
                            ? 'show'
                            : ''
                    }`}
                    style={style}
                >
                    <div className="holder-scores">
                        <CellJudgeScores
                            t={t}
                            athlete={athlete}
                            colors={colors}
                            scoreStyle={scoreStyle}
                            roundConfig={roundConfig}
                        />
                    </div>
                </div>
            )
        ];
    }
}



// WEBPACK FOOTER //
// ./src/views/Home/table/TableLeaderboard/scored/Row.js